import {ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-entity-sub-group-by-report-criteria",
    templateUrl: "./entity-sub-group-by-report-criteria.component.html"
})
export class EntitySubGroupByReportCriteriaComponent implements OnChanges {
    @Input() showLocationOption: boolean = true;
    @Input() showOutletOption: boolean = true;
    @Input() showInventoryOption: boolean = false;
    @Input() showInventoryGroupOption: boolean = false;

    constructor(public model: ReportModel<any>, public editService: EditService, private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["showInventoryGroupOption"]) {
            if (!this.showInventoryGroupOption && this.model.data.groupBy && this.model.data.groupBy.includes("inventoryGroup")) {
                this.model.data.groupBy = this.model.data.groupBy.filter((groupBy) => groupBy !== "inventoryGroup");
            }
        }
        if (changes["showOutletOption"]) {
            if (!this.showOutletOption && this.model.data.groupBy && this.model.data.groupBy.includes("outlet")) {
                this.model.data.groupBy = this.model.data.groupBy.filter((groupBy) => groupBy !== "outlet");
            }
        }
    }
}
